import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.index-of";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import analytics from '@nerdwallet/analytics';
import { ImpressionContext } from '@nerdwallet/analytics/react/impression';
import { CheckboxInline as Checkbox } from '@nerdwallet/react-checkbox';
import Button from '@nerdwallet/react-button';
import Check from '@nerdwallet/react-icon/gizmo/Check';
import Plus from '@nerdwallet/react-icon/gizmo/Plus';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import values from 'lodash/values';
import * as actions from '../redux/actions';
import './compare-card-checkbox.less';
var InteractionLocation = 'compare-card-checkbox';
export var CHECKBOX_STYLE = {
  CHECKBOX: 'checkbox',
  BUTTON: 'button'
};
export var CompareCardCheckbox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CompareCardCheckbox, _React$Component);

  var _super = _createSuper2(CompareCardCheckbox);

  function CompareCardCheckbox() {
    var _this;

    _classCallCheck(this, CompareCardCheckbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleCompareCardChange", function (e, addCardOverride) {
      if (e && e.target.checked || addCardOverride) {
        // Set a flag denoting we need to fetch more compare data
        var cardToAdd = cloneDeep(_this.props.card);
        cardToAdd.fetchCompareData = true;

        _this.props.saveToCompare({
          cards: [cardToAdd],
          productLocation: InteractionLocation
        });
      } else {
        _this.props.removeFromCompare(_this.props.card.id, InteractionLocation);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "fireAnalyticsEvent", function (isInCompare, impressionId) {
      var _this$props$analytics;

      if (((_this$props$analytics = _this.props.analytics) === null || _this$props$analytics === void 0 ? void 0 : _this$props$analytics.enabled) || _this.props.enableAnalytics) {
        var elementInteractedPayload = {
          entity_name: "product_card_compare",
          action: isInCompare ? 'unselect' : 'select',
          interaction_type: 'press'
        };

        if (impressionId) {
          elementInteractedPayload.impression_id = impressionId;
        }

        analytics.track('element_interacted', elementInteractedPayload);
      }
    });

    return _this;
  }

  _createClass(CompareCardCheckbox, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var cardIDsToCompare = get(this.props, 'compareCards.cardIDsToCompare') || [];
      var isInCompare = cardIDsToCompare.indexOf(this.props.card.id) > -1;
      var onChange = this.props.handleCompare || this.handleCompareCardChange;
      var classes = classnames('compare-checkbox', {
        'compare-checkbox--button': this.props.elementStyle === CHECKBOX_STYLE.BUTTON
      });

      var checkBoxClickHandler = function checkBoxClickHandler(e, impressionId) {
        _this2.fireAnalyticsEvent(isInCompare, impressionId);

        onChange(e);
      };

      var component = React.createElement(ImpressionContext.Consumer, null, function (value) {
        return React.createElement(Checkbox, {
          label: _this2.props.label,
          checked: isInCompare,
          onChange: function onChange(e) {
            return checkBoxClickHandler(e, value === null || value === void 0 ? void 0 : value.impressionId);
          }
        });
      }); // if the addText or removeText is undefined or an empty string
      // then use the default value else use the value passed in by the consumer

      var addText = this.props.addText || "Add to compare";
      var removeText = this.props.removeText || "Added to compare";

      if (this.props.elementStyle === CHECKBOX_STYLE.BUTTON) {
        var text = isInCompare ? removeText : addText;

        var buttonClickHandler = function buttonClickHandler(impressionId) {
          _this2.fireAnalyticsEvent(isInCompare, impressionId);

          onChange(null, !isInCompare);
        };

        component = React.createElement(ImpressionContext.Consumer, null, function (value) {
          return React.createElement(Button, {
            onClick: function onClick() {
              return buttonClickHandler(value === null || value === void 0 ? void 0 : value.impressionId);
            },
            className: "compare-button"
          }, isInCompare ? React.createElement(Check, {
            className: "icon",
            size: 16
          }) : React.createElement(Plus, {
            className: "icon",
            size: 16
          }), React.createElement("span", null, text));
        });
      }

      return React.createElement("div", {
        className: classes
      }, component);
    }
  }]);

  return CompareCardCheckbox;
}(React.Component);

_defineProperty(CompareCardCheckbox, "propTypes", {
  label: PropTypes.string,
  card: PropTypes.shape({
    id: PropTypes.number
  }).isRequired,
  // ** Deprecated use analytics prop instead **
  enableAnalytics: PropTypes.bool,
  analytics: PropTypes.shape({
    enabled: PropTypes.bool
  }),
  handleCompare: PropTypes.func,
  saveToCompare: PropTypes.func.isRequired,
  removeFromCompare: PropTypes.func.isRequired,
  elementStyle: PropTypes.oneOf(values(CHECKBOX_STYLE)),
  addText: PropTypes.string,
  removeText: PropTypes.string
});

_defineProperty(CompareCardCheckbox, "defaultProps", {
  label: 'Compare this card',
  elementStyle: CHECKBOX_STYLE.CHECKBOX,
  enableAnalytics: false,
  analytics: {
    enabled: false
  },
  addText: 'Add to compare',
  removeText: 'Added to compare'
});

var mapStateToProps = function mapStateToProps(_ref) {
  var compareCards = _ref.compareCards;
  return {
    compareCards: compareCards
  };
};

var mapDispatchToProps = {
  saveToCompare: actions.saveToCompare,
  removeFromCompare: actions.removeFromCompare
};
export default connect(mapStateToProps, mapDispatchToProps)(CompareCardCheckbox);
//# sourceMappingURL=compare-card-checkbox.js.map